import React, { Component, useRef, forwardRef } from 'react';
import { useSelector, useDispatch, connect } from 'react-redux';
import '../../../../styles/mainContents.css';
import fmplogo from '../../../../assets/FMP-Icon.png'

const CustomerCorePrintPage = forwardRef(function PrintPage(props, ref) {
    const { custnoDetailState} = props;

    let coreTable = (counter) => {

        var rowKey = counter + '_' + custnoDetailState['CUSTNO'];

        return (             
            <div key={rowKey} className='coreTableDivCN'>
                <table >
                    <thead>
                        <tr>
                            <td className={'logo'}>
                                <img src={fmplogo} alt='FMP Logo' width={142}/>                                        
                                <br/>
                                <span className={'fmpCorpAddress'}>                                        
                                    2782 EAGANDALE BOULEVARD<br/>
                                    EAGAN, MN 55121-1202<br/>
                                    Phone: 651-405-3610 --- Questions/Concerns: 920-224-2445 
                                </span>
                            </td>                            
                            <th>Customer Core Pickup</th>
                        </tr>
                    </thead>
                    <tbody >                
                        <tr>
                            <td colSpan={2}>
                                <table>
                                    <thead>                                        
                                    </thead>
                                    <tbody className='customerCoreHeading'>
                                        <tr>                               
                                            <td>Customer#:</td>
                                            <td>{custnoDetailState['CUSTNO']}</td>
                                        </tr>
                                        <tr>   
                                            <td>Custname:</td>
                                            <td>{custnoDetailState['CUSTNAME']}</td>
                                        </tr>           
                                        <tr>   
                                            <td>Address:</td>
                                            <td>
                                                {custnoDetailState['ADDRESS']}
                                                <br/>{custnoDetailState['CUSTCITY']}, {custnoDetailState['CUSTSTATE']} {custnoDetailState['ZIP']}
                                                <br/>{ custnoDetailState['PHONE'] }  
                                                <br/>{ custnoDetailState['EMAIL'] }                       
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>

                    </tbody> 
                </table> 

                {custnoDetailState['WARRANTY_EXCLUSIONS'] === false ? 
                    <div >
                        <hr/>
                        Qty of Batteries Returned for Warranty Request __________________
                        <br/>
                        (DO NOT include warranty batteries in count below) 
                        <br/>
                        Customer must include battery warranty form for warranty credit requests. Part numbers, other info, and date codes required
                        <hr/>
                    </div>                
                : ''
                }


                <div style={{paddingTop:'10px',fontWeight:'bolder',textDecorationLine:'underline' }}>
                    Battery Cores Collected
                </div>  

                <div style={{padding:'2px'}}>
                    Customer PO/Comments __________________________________________
                </div> 

                <table>
                    <thead>
                        <tr>
                            <th>Type</th>
                            <th>Pickup Qty</th>
                        </tr>
                    </thead>
                    <tbody>                
                        <tr>   
                            <td>BCRSM-CORE (U1's, Small SLA's, Power Sport)</td>
                            <td>_______________</td>
                        </tr>
                        <tr>   
                            <td>BCRMD-CORE (Auto/Marine not group 31)</td>
                            <td>_______________</td>
                        </tr>           
                        <tr>   
                            <td>BCRLG-CORE (4D, 8D & All group 31)</td>
                            <td>_______________</td>
                        </tr>
                        <tr>   
                            <td>BCRCOREGOLF-EA (Golf)</td>
                            <td>_______________</td>
                        </tr>                                                                                                       
                    </tbody> 
                </table>  

                <table className='signatureTblCN'>
                    <thead></thead>
                    <tbody>
                        <tr>                                
                            <td className='footerSignatureBoxColCN'    style={{paddingLeft:'3px'}}>
                                <table>
                                    <thead></thead>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <table>
                                                    <thead></thead>
                                                    <tbody>
                                                        <tr>
                                                            <td className='footerSignatureBoxCN'>Customer's Signature</td>
                                                            <td>_____________________________</td>
                                                        </tr>
                                                        <tr>
                                                            <td className='footerSignatureBoxCN'>Print Name</td>
                                                            <td>_____________________________</td>
                                                        </tr>
                                                        <tr>
                                                            <td className='footerSignatureBoxCN'>Date</td>
                                                            <td>_____________________________</td>
                                                        </tr>    
                                                    </tbody>                                            
                                                </table>
                                            </td>
                                            <td>
                                                <table>
                                                    <thead></thead>
                                                    <tbody>
                                                        <tr>
                                                            <td className='footerSignatureBoxCN'>Driver's Signature</td>
                                                            <td>_____________________________</td>
                                                        </tr>
                                                        <tr>
                                                            <td className='footerSignatureBoxCN'>Print Name</td>
                                                            <td>_____________________________</td>
                                                        </tr>
                                                        <tr>
                                                            <td className='footerSignatureBoxCN'>Date</td>
                                                            <td>_____________________________</td>
                                                        </tr>
                                                    </tbody>                                         
                                                </table>
                                            </td>                                
                                        </tr> 
                                    </tbody>
                                                
                                </table>
                            </td>
                        </tr>
                    </tbody>

                </table>  


                <div style={{paddingTop:'8px'}}>
                    <hr/>
                    ----- Internal Use Only -----
                </div>

                <div style={{paddingTop:'5px',fontWeight:'bolder',textDecorationLine:'underline' }}>
                     Rotate Request
                </div> 
                <table>
                    <thead>
                        <tr>
                            <th>Partno (i.e. FVPP65)</th>
                            <th>Voltage</th>
                            <th>Date Code</th>
                        </tr>
                    </thead>
                    <tbody>                
                        <tr>   
                            <td>___________________________</td>
                            <td>_______________</td>
                            <td>_______________</td>
                        </tr>
                        <tr>   
                            <td>___________________________</td>
                            <td>_______________</td>
                            <td>_______________</td>
                        </tr>
                        <tr>   
                            <td>___________________________</td>
                            <td>_______________</td>
                            <td>_______________</td>
                        </tr>                                                                                                                                                 
                    </tbody>
                </table>       

                <div>
                    <div style={{paddingTop:'5px',fontWeight:'bolder',textDecorationLine:'underline' }}>
                        New Battery Return
                    </div> 
                    <table>
                        <thead>
                            <tr>
                                <th>Partno (i.e. FVPP48)</th>
                                <th>Qty</th>
                                <th>Partno (i.e. FVPP48)</th>
                                <th>Qty</th>                                
                            </tr>
                        </thead>
                        <tbody>                
                            <tr>   
                                <td>___________________________</td>
                                <td>_______________</td>
                                <td>___________________________</td>
                                <td>_______________</td>                                
                            </tr>
                            <tr>   
                                <td>___________________________</td>
                                <td>_______________</td>
                                <td>___________________________</td>
                                <td>_______________</td>                                
                            </tr>
                            <tr>   
                                <td>___________________________</td>
                                <td>_______________</td>
                                <td>___________________________</td>
                                <td>_______________</td>                                
                            </tr>   
                            <tr>   
                                <td>___________________________</td>
                                <td>_______________</td>
                                <td>___________________________</td>
                                <td>_______________</td>                                
                            </tr>                                                                                                                                                                               
                        </tbody>
                    </table>
                </div>    
                         
            </div>            
        ) 
    }
    
    let PageBreak = () => {
        return (
            <tbody key={'componentKey'} style={{border:'none', visibility: 'hidden'}}>
                <tr><td className='pageBreakCL' colSpan={10} style={{border:'none', visibility: 'hidden'}}></td></tr>
            </tbody>
        )
    }
        
    return (
        <div className='page'>

        {/* {console.log('InvoicesPrintPage Object.keys(invoicesPrintState).length: ',  Object.keys(invoicesPrintState).length )}
        {console.log('InvoicesPrintPage invoicesPrintState: ',  invoicesPrintState )} */}

        
        {coreTable(0)}

        {/* Requested for duplicate copy of invoice printout */}
        <table key={'_TblPageBreakEndOfComponent'}>
            <thead></thead>
            {PageBreak('EndOfComponent', 'EndOfComponent','_PageBreakEndOfComponent')}
        </table>  

        {coreTable(1)}

        </div>
    );
})


const mapStateToProps = (state) => {
   return {
    custnoDetailState: state.customersReducer['items_fetchCustnoDetail'],

   }
  
};
  
const mapDispatchToProps = (dispatch) => {
    return {
       
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomerCorePrintPage);